export default "__VITE_ASSET__BBp_ZdMc__"